import types from './types';

export const fetchPermissions = () => ({
  type: types.FETCH_PERMISSIONS,
});
export const fetchPermissionsSuccess = ({ permissions }) => ({
  type: types.FETCH_PERMISSIONS_SUCCESS,
  payload: { permissions },
});
